import { Component, OnInit } from '@angular/core';
import { UiHelper } from '@helpers/ui.helper';
import { LocalizationService } from '@services/localization.service';
import { DataHelper } from '@helpers/data.helper';
import { Router } from '@angular/router';
import { ApiService } from '@services/api.service';
import { StandingsDialogComponent } from '@components/standings.dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '@environments/environment';
import { UserHelper } from '@helpers/user.helper';

@Component({
  selector: 'left-menu',
  templateUrl: '../sharedTemplates/left-menu.component.html',
})
export class LeftMenuComponent implements OnInit {
  //b3000
  topCountries = [];
  mainData = [];
  selectedSportId: any;
  lastReturned_dayFilter = 0;
  _dayFilter = 300;
  selectedLeagueData = [];
  narvbarDateTimeInterval;
  narvbarDateTime = '';
  leftMenuData = [
    {
      sportId: 1,
      routeId: 1,
      index: 0,
      svgPath: `sports`,
      title: 'Football',
    },
    {
      sportId: 2,
      routeId: 2,
      index: 2,
      svgPath: `basketball`,
      title: 'Basketball',
    },
    {
      sportId: 5,
      routeId: 5,
      index: 3,
      svgPath: `tennis`,
      title: 'Tennis',
    },
    {
      sportId: 4,
      routeId: 4,
      index: 1,
      svgPath: `icehockey`,
      title: 'Ice_Hockey',
    },
    {
      sportId: 6,
      routeId: 6,
      index: 4,
      svgPath: `handball`,
      title: 'Handball',
    },
    {
      sportId: 20,
      routeId: 20,
      index: 5,
      svgPath: `volleyball`,
      title: 'Volleyball',
    },
    {
      sportId: 17,
      routeId: 1,
      index: 12,
      svgPath: `tabletennis`,
      title: 'b3000_Table_Tennis',
    },
    {
      sportId: 14,
      routeId: 14,
      index: 6,
      svgPath: `football`,
      title: 'b3000_A_Football',
    },
    {
      sportId: 19,
      routeId: 19,
      index: 8,
      svgPath: `darts`,
      title: 'darts',
    },
    {
      sportId: 24,
      routeId: 24,
      index: 7,
      svgPath: `sports`,
      title: 'Futsal',
    },
  ];
  leftMenuGeneralData = [
    {
      routerLink: '/casinolobby',
      svgPath: ``,
      title: 'Casino',
      projectControl: ['b500'],
      ngIf: () => this._UserHelper.isSignedIn,
      order: 1,
    },
    {
      standingType: 'livescore',
      svgPath: `statistiken`,
      title: 'b3000_statistics',
      projectControl: [],
      ngIf: () => true,
      order: 2,
    },
    {
      standingType: 'statistics',
      svgPath: `ergebnisse`,
      title: 'Results',
      projectControl: [],
      ngIf: () => true,
      order: 3,
    },
    {
      routerLink: '/fav',
      svgPath: `favoriten`,
      title: 'Favourite',
      projectControl: [],
      ngIf: () => true,
      order: 4,
    },
  ];

  constructor(
    public _UiHelper: UiHelper,
    public _LocalizationService: LocalizationService,
    private _DataHelper: DataHelper,
    private _router: Router,
    private _ApiService: ApiService,
    public dialog: MatDialog,
    public _UserHelper: UserHelper
  ) {
    this._UiHelper.currentRouteListener.subscribe((x: any) => {
      this.closeLeftMenu();
    });
    this._DataHelper.LeagueDataListener.subscribe(x => {
      if (this._DataHelper.LeagueData != undefined) {
        this.selectedLeagueData = this._DataHelper.LeagueData;
      }
    });
  }

  leftSportMenuOpen() {
    this._DataHelper.LeagueData = undefined;
    this._DataHelper.leftMenuSportData = undefined;
    this._UiHelper.setLeftSportsMenuDialog(true);
    this._UiHelper.setLeftMenu();
  }

  ngOnInit() {
    this._DataHelper.leftMenuSportData = undefined;

    if (this._DataHelper.leftMenuSportData != undefined) {
      if (this._DataHelper.leftMenuSportData.length != 0) this.mainData = this._DataHelper.leftMenuSportData;
      else this.getSports();
    } else this.getSports();

    this.changeDayFilter({ source: null, value: '300' });
  }
  ngAfterViewInit() {
    this.narvbarDateTimeInterval = setInterval(() => {
      const narvbarTime = new Date().toLocaleTimeString();
      const narvbarDate = new Date().toLocaleDateString();
      this.narvbarDateTime = narvbarDate + ' - ' + narvbarTime;
    }, 1000);
  }
  ngOnDestroy() {
    if (this.narvbarDateTimeInterval) {
      clearInterval(this.narvbarDateTimeInterval);
    }
  }

  leftMenuGeneralDataRebuild(values) {
    return values.filter(item => (item.projectControl.length > 0 ? item.projectControl.includes(environment.product) : true) && item.ngIf()).sort((a, b) => a.order - b.order);
  }
  languageChangeDialogOpener(x) {
    this._UiHelper.setLanguageChangerDialog(true);
  }

  closeMenu() {
    this._UiHelper.setLeftMenu();
  }

  goPopularPages(e) {
    this._UiHelper.setLeftMenu();
    this._router.navigate([e]);
  }

  closeLeftMenu() {
    this._UiHelper.b3000SetLeftMenuState('close');
    this._UiHelper.closeDimmer();
  }

  clickOutside(event: any) {
    if (event && event.targetElement.id != 'leftMenuIcon' && event.clickInside == false) {
      // this._UiHelper.b3000SetLeftMenuState('close');
    }
  }

  openStats(e) {
    const dialogRef = this.dialog.open(StandingsDialogComponent, {
      id: 'standingsDialogNoPadding',
      panelClass: 'standingsDialogClass',
      height: '90%',
      width: '90%',
      data: {
        tournamentId: '',
        sportId: '',
        betradarMatchId: '',
        type: e,
      },
    });
    this._UiHelper.closeDimmer();
  }
  getCountriesBySportsID(_sportID, _index) {
    // this.topCountries = [];
    // this.selectedSportId = _sportID;
    // this.mainData.forEach(element => {
    //   element['state'] = false;
    // });

    // this._ApiService.getCountriesBySportsID(this._dayFilter, _sportID).then((x) => {
    //   this.mainData[_index].level = x.map((x) => {
    //     x['level'] = [];
    //     x['state'] = false;
    //     x['loading'] = false;
    //     x['allselected'] = false;
    //     return x;
    //   });
    //   this.mainData[_index]['state'] = true;
    // });

    // this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
    const objSport = {
      sportId: _sportID,
      index: _index,
    };
    this._UiHelper.leftMenuSportSelected(objSport);
    this._UiHelper.closeDimmer();
  }
  getSports(__dayFilter = 300) {
    if (this.lastReturned_dayFilter != __dayFilter || this.lastReturned_dayFilter == 0) {
      this._ApiService
        .getSports(__dayFilter)
        .then(x => {
          this.mainData = x.map(x => {
            x['level'] = [];
            x['loading'] = false;
            x['state'] = false;
            return x;
          });
          this.lastReturned_dayFilter = __dayFilter;
          this.getCountriesBySportsID(1, 0);
        })
        .catch(err => console.log('left-menu', err));
    }
  }
  changeDayFilter(e) {
    if (e.value == undefined) {
      return;
    }

    this._DataHelper.leftMenuSportDayFilter = e.value;

    if (this._dayFilter != e.value) {
      e != undefined ? this.getSports(e.value) : null;
      this._dayFilter = e.value;
    }
  }
  openGameCasino() {
    if (this._UserHelper.isSignedIn) {
      const sessionid = '_' + Math.random().toString(36).substr(2, 9);
      this._ApiService.CasinoGameCreateToken(sessionid).then(result => {
        this.setCookie('gamesessionid', sessionid, 1, 'casino');
        window.location.href = result.url;
      });
    } else {
      this.closeLeftMenu();

      this._UiHelper.b3000SetRightMenuState('open');
    }
  }
  private setCookie(name: string, value: string, expireDays: number, path = '') {
    const d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 1 * 60 * 24 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    const cpath = `; path=/`;
    const domain = '.bet500.bet;path=/';
    const domain2 = '.games.bet500.bet;path=/';
    const domain3 = '.bet500.bet;path=/home';
    const domain4 = '.games.bet500.bet;path=/home';

    document.cookie = `${name}=${value}; ${expires}${cpath};domain=${domain};`;
    document.cookie = `${name}=${value}; ${expires}${cpath};domain=${domain2};`;
    document.cookie = `${name}=${value}; ${expires}${cpath};domain=${domain3};`;
    document.cookie = `${name}=${value}; ${expires}${cpath};domain=${domain4};`;

    // document.cookie = `${name}=${value}; ${expires}${cpath}; `;
  }
}
